<template>
<div class="row justify-content-center align-content-center">
  <div class="card m-1" style="width: 20rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/limpieza2.jpg" class="card-img-top" alt="Imagen limpieza datos" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <p class="card-text texto_base2">Se realiza una limpieza y Tranformación de los datos.
          Se revisan inconsistencias y valores atipicos. de esta forma se declaran los valores que estan fuera de rango como valores perdidos para poder identificarlos y eliminamos los valores perdidos.
          Así mismo se revisa la existencia de valores perdidos en la data y según el caso se eliminan o se imputan por el promedio o la moda.
          </p>
      </div>
  </div>

  <div class="card m-1" style="width: 20rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/modelos.jpg" class="card-img-top" alt="Imagen curvas roc" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body">
        <p class="card-text texto_base2">Un vez verificada la data, separamos el total de datos en datos de entrenamiento y de prueba.
        Posteriormente se entrenan los modelos con los datos de entrenamiento y se realiza cross-validation con el objetivo de encontrar los mejores parametros para cada modelo y de esta forma encontrar el que mas se ajuste a nuestros datos para que hagan una mejor predicción.
        Finalmente, se evalua el rendimiento de los modelos previamente entrenados para determinar su capacidad de predicción de la variable objetivo, para esto utilizamos los datos de prueba.
        </p>
      </div>
  </div>

  <div class="card m-1" style="width: 20rem; border-radius: 20px; box-shadow: 10px 10px 20px grey">
      <img src="../assets/clases.png" class="card-img-top" alt="Imagen estadistica profesor" style="border-radius: 20px 20px 0px 0px">
      <div class="card-body texto_base2">
        <p class="card-text">Profesor de Estadística.</p>
        <p>Docente con 15 años de experiencia ofrece clases de estadística, manejo de excel y spss para análisis de datos</p>
        <p>Docencia en las asignaturas de estadística descriptiva e inferencial</p>
        <p>Experiencia en análisis estadístico para diversos proyectos de investigación académica. Manejo de metodologías cuantitativas</p>
        <a href="https://www.superprof.cl/docente-con-anos-experiencia-ofrece-clases-estadistica-manejo-excel-spss-para-analisis-datos-tesis-pre.html" target="_blank" class="btn btn-primary">Ir al Sitio</a>
      </div>
  </div>

  
</div>
  
</template>

<script>
export default {
    name:'Estadistica',

}
</script>

<style>

</style>